var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "certificate", attrs: { id: _vm.model.sn } },
    [
      _c("div", { staticClass: "moduleName" }, [
        _c("p", [_vm._v(_vm._s(_vm.model.title))])
      ]),
      _c("span", { staticClass: "date" }, [_vm._v("Bodyswaps")]),
      _vm.model.completed
        ? _c("span", { staticClass: "userName" }, [
            _vm._v(_vm._s(_vm.$t("certificate.completed-by"))),
            _c("br"),
            _c("em", [_vm._v(_vm._s(_vm.model.userName))]),
            _c("br"),
            _vm._v(_vm._s(_vm.formatDate(_vm.model.completed)))
          ])
        : _vm._e(),
      !_vm.model.completed
        ? _c("span", { staticClass: "userName" }, [_vm._v("Still in progress")])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }